import PropTypes from 'prop-types';

const PageHeader = ({ title, children }) => {
  return (
    <div className='border-bottom mt-5 p-lg-0 p-xl-0 mb-4'>
      <h1 className='fw-normal fs-2 mb-4'>{title}</h1>
      {children ? <p className='px-3 py-2 border-start border-4 fs-5 mb-4'>{children}</p> : ''}
    </div>
  );
};

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
};

PageHeader.defaultProps = {
  title: 'Título',
};

export default PageHeader;
